
namespace Nbs.Xlr8PageTemplate.Footer {
  let footerText: string[] | undefined;
  let footerLinks: Navigation.Link[] | undefined;
  let linksClickHandler: undefined | ((menuItem: Navigation.MenuItem) => boolean);

  export function getHeight() {
    const el = Utilities.getFirstElement('nbs-footer');
    if (!el) {
      return 0;
    }
    const footerEl = el.firstElementChild;
    return footerEl ? footerEl.clientHeight : 0;
  }

  export function render() {
    const footerRoot = Utilities.getNbsFooterElement();
    Utilities.replaceChildren(footerRoot, [getFooterElement()]);
  }

  export function hideLinks() {
    const div = Utilities.getFirstElementByClass('xpt-footer-links');
    Utilities.addClass(div, 'xpt-display-none');
  }

  export function showLinks() {
    const div = Utilities.getFirstElementByClass('xpt-footer-links');
    Utilities.removeClass(div, 'xpt-display-none');
  }

  export function setLinks(items?: Navigation.Link[]) {
    footerLinks = items;
    renderLinks();
  }

  export function setLinksClickHandler(clickHandler?: ((menuItem: Navigation.MenuItem) => boolean)) {
    linksClickHandler = clickHandler;
  }

  export function setText(lines?: string[]) {
    footerText = lines;
    renderText();
  }

  export function renderLinks() {
    const div = Utilities.getFirstElementByClass('xpt-footer-links');
    Utilities.replaceChildren(div, [getFooterLinksElement()]);
  }

  export function renderText() {
    const div = Utilities.getFirstElementByClass('xpt-footer-text');
    Utilities.replaceChildren(div, getFooterTextElements());
  }

  export const onClick = (event: MouseEvent) => {
    return Navigation.handleClickEvent(event, footerLinks, linksClickHandler);
  }

  function getFooterElement() {
    return Utilities.createElement({
      tag: 'footer',
      children: [Utilities.createElement({
        classes: ['xpt-footer-container'],
        children: [
          Utilities.createElement({ classes: ['xpt-footer-links'], children: [getFooterLinksElement()] }),
          Utilities.createElement({ classes: ['xpt-footer-text'], children: getFooterTextElements() })
        ]
      })]
    });
  }

  function getFooterLinksElement() {
    return footerLinks ? Utilities.createElement({
      tag: 'ul',
      children: footerLinks.map(l => {
        const menuItems = Navigation.getMenuItemElements(l, onClick);

        const menuItemWrapper = l.url ? [Utilities.createElement({
          tag: 'a',
          attributes: Navigation.getLinkOnlyAttributes(l),
          eventHandlers: { click: onClick },
          children: menuItems
        })] : menuItems;

        return Utilities.createElement({ tag: 'li', children: menuItemWrapper })
      })
    }) : undefined;
  }

  function getFooterTextElements() {
    let footerLines: Node[] = [];
    if (footerText) {
      footerLines = footerText.map(txt => Utilities.createElement({ tag: 'p', classes: ['xpt-footer-text-line'], children: [txt] }));
    }

    let standardText: string;
    switch (document.documentElement.lang) {
      case 'es':
        standardText = 'Nelnet, Inc. y afiliados. Todos los derechos reservados.';
        break;
      default:
        standardText = 'Nelnet, Inc. and Affiliates. All Rights Reserved.';
        break;
    }

    const year = new Date().getFullYear();
    footerLines.push(Utilities.createElement({ tag: 'p', classes: ['xpt-footer-text-line'], children: [`© ${year} ${standardText}`] }));
    return footerLines;
  }
}
